import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-institucional-view',
  templateUrl: './institucional-view.component.html',
  styleUrls: ['./institucional-view.component.scss']
})
export class InstitucionalViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
